import $ from '../core/Dom';
import Dispatch from '../core/Dispatch';

import { FILTER_OPENED, FILTER_UPDATED } from '../lib/events';

export default (el, props) => {
    const $el = $(el);
    const $body = $('body');

    const isInStickyMenu = props.isInStickyMenu || false;

    const componentId = 'filterForm' + (1000000 + Math.floor(Math.random() * 8888888));
    let activeFilterPanel = null;
    let isUpdating = false;

    const init = () => {
        $el.on('click', '[data-filter-toggle]', onFilterToggle);
        $el.on('click', '[data-filter-panel-clear]', onPanelClear);

        $body.on('click', onBodyClick);
        $el.on('click', onElementClick);
        $el.on('change', onChange);
        
        Dispatch.on(FILTER_UPDATED, onFilterUpdated);
        Dispatch.on(FILTER_OPENED, onFilterOpened);
        
        document.addEventListener('keyup', onKeyUp);
    };

    const destroy = () => {
        $el.off('click');

        $body.off('click', onBodyClick);
        $el.off('click', onElementClick);

        Dispatch.off(FILTER_UPDATED, onFilterUpdated);
        Dispatch.off(FILTER_OPENED, onFilterOpened);

        document.removeEventListener('keyup', onKeyUp);
    };

    const onChange = () => {
        if (!isUpdating) {
            const formData = new FormData(el);
            const filter = new URLSearchParams(formData).toString();
            Dispatch.emit(FILTER_UPDATED, { id: componentId, formData, filter });
        }
    };
    
    const onFilterUpdated = (key, data) => {
        if (data.id !== componentId) {
            updateFilter(data.formData);
        }
    };
    
    const onFilterOpened = (key, data) => {
        if (data.id !== componentId) {
            if (activeFilterPanel !== null) {
                closeFilterPanel(activeFilterPanel);
            }
        }
    };

    const onBodyClick = e => {
        if (activeFilterPanel !== null) {
            closeFilterPanel(activeFilterPanel);
        }
    };

    const onElementClick = e => {
        e.stopImmediatePropagation();
    };

    const onKeyUp = e => {
        const key = e.keyCode || e.which;

        if (activeFilterPanel !== null && key === 27) {
            closeFilterPanel(activeFilterPanel);
        }
    };

    const onFilterToggle = e => {
        const $toggle = $(e.triggerTarget);
        const isOpen = $toggle.attr('aria-expanded') === 'true';

        if (isOpen) {
            closeFilterPanel($toggle.data('filter-toggle'));
        } else {
            openFilterPanel($toggle.data('filter-toggle'));

        }
    };

    const openFilterPanel = id => {
        if (activeFilterPanel !== null) {
            closeFilterPanel(activeFilterPanel);
        }

        const $panel = $el.find('#' + id);
        const $toggle = $el.find('[data-filter-toggle="' + id + '"]');

        $panel.css({ display: 'block' });
        $toggle.attr('aria-expanded', 'true');

        activeFilterPanel = id;

        if (isInStickyMenu) {
            $body.addClass('has-sticky-filter-open');
        }
        
        Dispatch.emit(FILTER_OPENED, { id: componentId, });
    };

    const closeFilterPanel = id => {
        const $panel = $el.find('#' + id);
        const $toggle = $el.find('[data-filter-toggle="' + id + '"]');

        $panel.css({ display: 'none' });
        $toggle.attr('aria-expanded', 'false');

        activeFilterPanel = null;

        if (isInStickyMenu) {
            $body.removeClass('has-sticky-filter-open');
        }
    };
    
    const updateFilter = formData => {
        isUpdating = true;

        // Reset all checkboxes and radios before applying new values
        $el.find('input[type="checkbox"], input[type="radio"]').each(node => {
            node.checked = false;
        });

        // Loop over the FormData entries and output their values
        formData.forEach((value, key) => {
            try {
                // Output to console for visibility/debugging
                // eslint-disable-next-line no-console
                console.debug('[FilterForm] FormData entry:', key, value);
            } catch (e) { /* no-op if console not available */ }

            // Find inputs with the matching name and set their state/value
            $el.find('input, select, textarea').each(node => {
                if (node.name === String(key)) {
                    if (node.type === 'checkbox' || node.type === 'radio') {
                        if (String(node.value) === String(value)) {
                            node.checked = true;
                        }
                    } else {
                        node.value = value;
                    }
                }
            });
        });

        isUpdating = false;
    };

    const onPanelClear = e => {
        const $target = $(e.triggerTarget);
        const $panel = $target.parent().parent();

        // Find all checkboxes and radio buttons within the panel and reset them
        $panel.find('input[type="checkbox"], input[type="radio"]').each(node => {
            node.checked = false;
        });

        onChange();
    };

    return {
        init,
        destroy
    };
};
